import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconTelegram = (props) => /* @__PURE__ */ _jsx("svg", {
	"data-name": "Icon - Telegram",
	xmlns: "http://www.w3.org/2000/svg",
	width: 21.726,
	height: 18,
	viewBox: "0 0 21.726 18",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		"data-name": "Group 2119",
		children: /* @__PURE__ */ _jsx("path", {
			"data-name": "Path 5421",
			d: "M1.487 7.763q8.746-3.8 11.662-5.031C18.7.416 19.863.017 20.612-.001a1.337 1.337 0 0 1 .788.234.882.882 0 0 1 .283.55 2.879 2.879 0 0 1 .033.783c-.3 3.165-1.6 10.845-2.266 14.377-.283 1.5-.833 2-1.366 2.049-1.166.1-2.049-.766-3.165-1.5-1.766-1.149-2.749-1.866-4.465-3-1.982-1.3-.7-2.016.433-3.182.3-.3 5.414-4.964 5.514-5.381a.4.4 0 0 0-.1-.35.459.459 0 0 0-.416-.033c-.183.033-2.982 1.9-8.43 5.581a3.753 3.753 0 0 1-2.166.8 14.42 14.42 0 0 1-3.119-.728c-1.249-.4-2.249-.62-2.17-1.32.05-.367.55-.733 1.483-1.116",
			fill: "currentColor",
			fillRule: "evenodd"
		})
	})
});
export { SvgIconTelegram as ReactComponent };
